import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-226854e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow area-authorInfo" }
const _hoisted_2 = { class: "title-area" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "著者情報", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 情報提供 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "著者ID", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "著者名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "著者別名", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "生年", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "没年", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "関連情報１", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "関連情報２", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", { class: "explan-list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "著作権の確認は著作物ごとに行っており、著作者の情報が不明でも、著作物の著作権について問題ないと判断した場合は、保護期間満了としてインターネット公開している場合があります。")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_AppButton, {
        onClick: _ctx.toAuthorInput,
        onKeydown: _withKeys(_withModifiers(_ctx.toAuthorInput, ["prevent"]), ["space","enter"]),
        buttonId: 'button-toAuthorInput'
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick", "onKeydown"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.authorId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.authorName), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.authorAliasName), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.birthYear ? `${_ctx.props.authorInfo.birthYear}年` : ''), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.deathYear ? `${_ctx.props.authorInfo.deathYear}年` : ''), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.info), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_ctx.props.authorInfo.info2), 1)
          ])
        ])
      ])
    ]),
    _hoisted_12
  ]))
}